export const QK = {
  clients:   (filters) => ['clients', filters],
  customers: (filters) => ['customers', filters],
  catalog:   (filters) => ['catalog', filters],
  dashboard: ()        => ['dashboard'],
  hrStats:   ()        => ['hr', 'stats'],
  employees: (filters) => ['hr', 'employees', filters],
};
